<template>
  <div style="background: #F9F9FA;">
    <div class="content-box subject-banner">
      <div class="content-detail">
        <p class="title">课题立项</p>
        <p class="text">重视教学研究 开展教研课题申报 助力课题成功立项</p>
        <button class="btn">查看详情</button>
      </div>
    </div>
    <div class="content-box tabs-content">
      <div class="content-detail">
        <ul class="tabs">
          <li class="li" :class="{'active': tabIndex === item.id}" v-for="(item, index) in tabList" :key="index" @click="tabClick(item)">{{item.name}}</li>
        </ul>
      </div>
    </div>
    <div class="content-box subject-content">
      <div class="content-detail">
        <ul class="subject-list">
          <li class="li" :class="{'margin24': (index + 1) % 3 !== 0}" v-for="(item, index) in showList" :key="index">
            <a :href="item.url?item.url:'javascript:;'" :target="item.url?'_blank':''">
              <img class="img" :src="`${item.imgUrl}`"/>
              <p class="title">
                <span class="margin title-name">{{item.projectName}}</span>
                <span v-if="tabList[item.type]" class="level" :class="'color'+tabList[item.type].id">
                  {{tabList[item.type].name}}
                </span>
              </p>
              <p class="li-info margin">
                <img class="img" src="/static/img/teaching/person.png" alt="">
                <span class="label">项目负责人</span>
                <span class="name">{{item.projectCurator}}</span>
              </p>
              <p class="li-info">
                <img class="img" src="/static/img/teaching/school.png" alt="">
                <span class="label">高校名称</span>
                <span class="name">{{item.universityName}}</span>
              </p>
            </a>
          </li>
        </ul>
        <div class="more" v-show="showList.length < allList.length">
          <button @click="getMore">了解更多<i class="el-icon-arrow-right i1"></i><i class="el-icon-arrow-right i2"></i><i class="el-icon-arrow-right i3"></i></button>
        </div>
      </div>
    </div>
    <div class="empty" v-show="!allList.length">
      <img src="/static/img/empty.png">
      <p>没有更多了~</p>
    </div>
  </div>
</template>

<script>
import { subjectServer } from '@/api/api'
import getImgUrl from '@/mixin/getImgUrl.js'
export default {
  mixins: [getImgUrl],
  data () {
    return {
      tabList: [
        { name: '全部', id: '0' },
        { name: '教育部', id: '1' },
        { name: '教育厅', id: '2' },
        { name: '高校', id: '3' },
        { name: '科技局', id: '4' },
        { name: '卫生局', id: '5' },
        { name: '其他', id: '6' }
      ],
      tabIndex: '0',
      showList: [],
      allList: [],
      showIndex: 0
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    tabClick (item) {
      if (this.tabIndex === item.id) return
      this.tabIndex = item.id
      this.getList()
    },
    getList () {
      this.allList = []
      this.showList = []
      subjectServer.getSubjectList({
        type: this.tabIndex
      }).then((res) => {
        let { code, data } = res
        if (code === '0') {
          this.allList = data
          this.getImgUrl(this.allList, 'img')
          this.showList = data.slice(0, 6)
          this.showIndex = 6
        }
      })
    },
    getMore () {
      if (this.allList.length > this.showList.length) {
        this.showIndex += 6
        if (this.allList.length > this.showIndex) {
          this.showList = this.allList.slice(0, this.showIndex)
        } else {
          this.showList = this.allList
        }
      }
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less" scoped>
@import "~less-lib";
@media (min-width: 1920px) {
  .subject-banner{
    background: url("/static/img/teaching/subject.png") no-repeat;
  }
}
@media (max-width: 1920px) {
  .subject-banner{
    background: url("/static/img/teaching/subject1.jpg") no-repeat;
  }
}
.subject-banner{
  height: 560px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .content-detail {
    height: 560px;
    padding-top: 102px;
    text-align: left;
  }
  .title {
    font-family: AlibabaPuHuiTi-Medium;
    font-size: 80px;
    line-height: 110px;
    color: #FFFFFF;
    letter-spacing: 7.11px;
    margin-bottom: 26px;
  }
  .text {
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 30px;
    line-height: 42px;
    color: #FFFFFF;
    letter-spacing: 2.67px;
    font-weight: 400;
  }
  .btn {
    width: 126px;
    height: 46px;
    line-height: 46px;
    background: #FFFFFF;
    border-radius: 4px;
    font-family: SourceHanSansSC-Medium;
    font-size: 16px;
    color: #0C59EF;
    letter-spacing: 1.42px;
    position: absolute;
    left: 0;
    bottom: 120px;
    cursor: pointer;
  }
}
.tabs-content {
  background-color: #fff;
  margin-bottom: 100px;
  .tabs {
    height: 64px;
    text-align: left;
    .li {
      display: inline-block;
      height: 64px;
      line-height: 64px;
      font-family: SourceHanSansSC-Medium;
      font-size: 14px;
      color: #000000;
      border-bottom: 1px solid #fff;
      margin-right: 50px;
      cursor: pointer;
    }
    .active {
      color: #0C59EF;
      border-bottom: 1px solid #0C59EF;
    }
  }
}
.subject-content {
  .subject-list {
    text-align: left;
    .li {
      width: 384px;
      height: 540px;
      border-radius: 14px;
      overflow: hidden;
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
      margin-bottom: 40px;
      display: inline-block;
      position: relative;
    }
    .margin24 {
      margin-right: 24px;
    }
    .li:nth-child(odd) {
      // margin-right: 48px;
    }
    .img {
      width: 384px;
      height: 288px;
      margin-bottom: 20px;
    }
    .title {
      width: 344px;
      font-family: SourceHanSansSC-Medium;
      font-size: 24px;
      line-height: 33px;
      color: #000000;
      margin-left: 20px;
      margin-bottom: 16px;
      text-align: left;
      span {
        font-family: SourceHanSansSC-Medium;
      }
      .title-name{
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-inline-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        vertical-align: middle;
      }
    }
    .li-info {
      margin-left: 20px;
      font-size: 14px;
      font-weight: 400;
      .img{
        width: 22px;
        height: 22px;
        margin-bottom: 0;
        vertical-align: middle;
      }
      .label{
        display: inline-block;
        width: 70px;
        margin-left: 10px;
        color: #666666;
      }
      .name{
        margin-left: 14px;
        color: #333333;
      }
    }
    .li-info.margin{
      margin-bottom: 20px;
    }
    .margin {
      margin-right: 24px;
    }
    .level {
      padding: 0 9px;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      border-radius: 4px;
      border: 1px solid #0C59EF;
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      line-height: 22px;
      height: 24px;
      color: #0C59EF;
    }
    .color1 {
      border: 1px solid #2FA120;
      color: #2FA120;
    }
    .color3 {
      border: 1px solid #E7871E;
      color: #E7871E;
    }
    .color4 {
      border: 1px solid #0D97D2;
      color: #0D97D2;
    }
    .color5 {
      border: 1px solid #6425D0;
      color: #6425D0;
    }
    .color6 {
      border: 1px solid #AA7902;
      color: #AA7902;
    }
    .info {
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      color: #666666;
      text-align: left;
      padding-left: 20px;
    }
  }
  .more {
    padding: 96px 0 120px 0;
    button {
      height: 25px;
      line-height: 25px;
      font-family: SourceHanSansSC-Medium;
      font-size: 18px;
      color: #666666;
      background: none;
      cursor: pointer;
      position: relative;
      width: 105px;
      text-align: left;
    }
    i {
      color: #979797;
      position: absolute;
      top: 3px;
    }
    .i1 {
      right: 14px;
    }
    .i2 {
      opacity: .6;
      right: 7px;
    }
    .i3 {
      opacity: .4;
      right: 0;
    }
    button:hover {
      color: #0C59EF;
      i {
        color: #0C59EF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teaching/subject.vue